export const toFirstAndLastName = (name = '') => {
  const [firstName = '', ...last] = (name || '').split(' ')
  const lastName = last.join(' ')
  return {
    firstName,
    lastName
  }
}